var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8652 8.99914L6.86521 1.99914C6.77799 1.84524 6.65151 1.71723 6.49867 1.62817C6.34583 1.53911 6.1721 1.49219 5.99521 1.49219C5.81831 1.49219 5.64459 1.53911 5.49175 1.62817C5.33891 1.71723 5.21243 1.84524 5.12521 1.99914L1.12521 8.99914C1.03705 9.15182 0.990823 9.32509 0.991213 9.50139C0.991604 9.67769 1.0386 9.85076 1.12743 10.003C1.21627 10.1553 1.34378 10.2814 1.49706 10.3686C1.65033 10.4557 1.82391 10.5007 2.00021 10.4991H10.0002C10.1757 10.499 10.348 10.4526 10.4998 10.3648C10.6517 10.2769 10.7778 10.1507 10.8655 9.99869C10.9531 9.8467 10.9992 9.67433 10.9992 9.49888C10.9991 9.32343 10.9529 9.15108 10.8652 8.99914Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5V6.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H6.005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fd1efbab34fe4ca44c5f5f30f9327c65.svg";
export { ForwardRef as ReactComponent };